module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921023834_T.bef54d5f.jpg";